<template>
  <div class="administrat warn-static mainContent">
    <div v-if="!showMore" class="main_content">
      <div class="query-box search">
        <div class="date_search">
          <!-- 查询条件 -->
          <SearchDate @handleSearch="handleSearch" :searchDate="currenNode" ref="searchDate"></SearchDate>
        </div>
        <!-- 机构树搜索 -->
        <div class="searchTree">
          <SearchTree @currentNode="currentNode"></SearchTree>
        </div>
        <el-button type="primary" class="serachBtn" size="small" @click="handleChild">
          {{ $t('query') }}
        </el-button>
      </div>
      <!--  左侧 -->
      <transition name="moveL">
        <div class="left_li" v-show="warnFlag" key="box1">
          <!--  跌落告警统计 -->
          <div class="content_box" :class="{ content_box_three_row: !isSupportIH5 }">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.dropTitle }}: {{ alarmTotal.dropTotlal }}</div>
              </div>
              <div
                class="check_more"
                v-if="dropBarData.allXData.length > 10"
                @click="checkMore(mainTitle.dropTitle, dropBarData, 'bar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="alarm_statu">
              <PersonMedia :barData="dropBarData"></PersonMedia>
            </div>
          </div>

          <!--  进入禁区统计 -->
          <div class="content_box" :class="{ content_box_three_row: !isSupportIH5 }">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.planeTitle }}: {{ alarmTotal.planeTotle }}</div>
              </div>
              <div
                class="check_more"
                v-if="alarmTotal.planeTotle > 4"
                @click="checkMore(mainTitle.planeTitle, allPlaneList, 'bar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="equipment_num">
              <div class="amount" v-for="(item, indx) in planeList" :key="indx">
                <div class="num">{{ item.number }}</div>
                <el-tooltip class="item" effect="dark" :content="item.userName" placement="bottom">
                  <div class="equip_name">{{ item.userName }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="center-li" :class="!isSupportIH5 ? 'ih5-center' : ''">
        <div class="center-alarm alarm-up">
          <!--  脱帽告警统计 -->
          <div class="content_box" :class="{ content_box_three_row: !isSupportIH5 }">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.hatTitle }}: {{ alarmTotal.hatTotlal }}</div>
              </div>
              <div
                class="check_more"
                v-if="hatList.allXData.length > 10"
                @click="checkMore(mainTitle.hatTitle, hatList, 'cone')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="alarm_statu">
              <RaiseHatAlarm :barWidth="barWidth" :hatList="hatList"></RaiseHatAlarm>
            </div>
          </div>

          <!--  心率告警统计 -->
          <div v-if="isSupportIH5" class="content_box heart_alarm">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.heartTitle }}: {{ alarmTotal.heartTotlal }}</div>
              </div>
              <div
                class="check_more"
                v-if="heartBarData.allXData.length > 10"
                @click="checkMore(mainTitle.heartTitle, heartBarData, 'bar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="alarm_statu">
              <PersonMedia :barData="heartBarData"></PersonMedia>
            </div>
          </div>
        </div>
        <!-- 中间下行 -->
        <div class="center-alarm alarm-down">
          <!--  血氧告警统计 -->
          <div v-if="isSupportIH5" class="content_box">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.bloodTitle }}: {{ alarmTotal.bloodTotlal }}</div>
              </div>
              <div
                class="check_more"
                v-if="alarmTotal.bloodTotlal > 4"
                @click="checkMore(mainTitle.bloodTitle, allBloodList, 'bar')"
              >
                {{ $t('SeeMore') }}
              </div>
            </div>
            <div class="equipment_num">
              <div class="amount" v-for="(item, indx) in bloodList" :key="indx">
                <div class="num">{{ item.number }}</div>
                <el-tooltip class="item" effect="dark" :content="item.userName" placement="bottom">
                  <div class="equip_name">{{ item.userName }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <!--  一键求助告警统计 -->
          <div class="content_box help_alarm" :class="{ content_box_three_row: !isSupportIH5 }">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.helpTitle }}: {{ alarmTotal.helpTotlal }} </div>
              </div>
              <div
                class="check_more"
                v-if="alarmTotal.helpTotlal > 10"
                @click="checkMore(mainTitle.helpTitle, helpBarData, 'bar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="alarm_statu">
              <PersonMedia :barData="helpBarData"></PersonMedia>
            </div>
          </div>
        </div>
      </div>
      <!--  右侧 -->
      <transition name="moveR">
        <div class="right_li" v-show="warnFlag" key="box2">
          <!--  静止告警统计  -->
          <div class="content_box" :class="{ content_box_three_row: !isSupportIH5 }">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.staticTitle }}: {{ alarmTotal.staticTotlal }}</div>
              </div>
              <div
                class="check_more"
                v-if="alarmTotal.staticTotlal > 4"
                @click="checkMore(mainTitle.staticTitle, allAmountList, 'bar')"
              >
                {{ $t('SeeMore') }}
              </div>
            </div>
            <div class="equipment_num">
              <div class="amount" v-for="(item, indx) in amountList" :key="indx">
                <div class="num">{{ item.number }}</div>
                <el-tooltip class="item" effect="dark" :content="item.userName" placement="bottom">
                  <div class="equip_name">{{ item.userName }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>

          <!--  撞击告警统计 -->
          <div class="content_box" :class="{ content_box_three_row: !isSupportIH5 }">
            <div class="record">
              <div class="title_box">
                <div class="new_title">{{ mainTitle.hitTitle }}: {{ alarmTotal.hitTotlal }}</div>
              </div>
              <div
                class="check_more"
                v-if="alarmTotal.hitTotlal > 8"
                @click="checkMore(mainTitle.hitTitle, allHitList, 'bar')"
              >
                {{ $t('SeeMore') }}>
              </div>
            </div>
            <div class="hit_alarm alarm_statu" :class="hitList.length > 4 ? '' : 'hit_hat'">
              <div
                :class="hitList.length > 4 ? 'safety_hat' : 'three_hat'"
                :style="hitList.length === 3 ? 'width: 32%' : hitList.length === 2 ? 'width: 50%' : 'width: 25%'"
                v-for="(item, index) in hitList"
                :key="index"
              >
                <div class="hat-num">
                  <div class="hit_num">{{ item.number }}</div>
                  <el-tooltip class="item" effect="dark" :content="item.userName" placement="bottom">
                    <p>{{ item.userName }}</p>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="showMore === true" class="main_content">
      <CheckMore @backHome="backHome" :moreTitle="moreTitle" :type="echartType" :echartData="echartData"></CheckMore>
    </div>
  </div>
</template>

<script>
// 依赖组件
import PersonMedia from '@/views/new-person/PersonMedia.vue'
import RaiseHatAlarm from '@/views/new-warn/RaiseHatAlarm.vue'
import SearchDate from '@/views/new-home/SearchDate.vue'
import SearchTree from '@/views/new-home/SearchTree.vue'
import CheckMore from '@/views/new-more/CheckMore.vue'
// 依赖工具
import { nowDate, beforeMonthDate } from '@/util/date'
import { sortData } from '@/util/common'
import { alertCountPage, emergencyHelpPage } from '@/api/new-warn/newWarn'
import { mapGetters } from 'vuex'
export default {
  components: {
    PersonMedia,
    RaiseHatAlarm,
    SearchDate,
    SearchTree,
    CheckMore,
  },
  data() {
    return {
      // 显示动画
      warnFlag: false,
      // 查看更多的 框的标题，方便传值
      mainTitle: {
        heartTitle: this.$t('Heartratealarmstatistics'),
        bloodTitle: this.$t('BloodoxygenalarmTotal'),
        hatTitle: this.$t('Offhataarmstatistics'),
        electricitTitle: this.$t('StatisticElectrostaticAlarm'),
        hitTitle: this.$t('ImpactAlarmStatistics'),
        dropTitle: this.$t('DropAlarmStatistics'),
        staticTitle: this.$t('StaticAlarmStatistics'),
        helpTitle: this.$t('helpAlarmStatistics'),
        planeTitle: this.$t('OutPlaneAlarm'),
      },
      // 血氧数据
      bloodList: [],
      // 血氧告警更多柱状图数据
      allBloodList: {
        barId: 'helpId',
        color: ['#FFD96A'],
        allXData: [],
        allBarData: [],
        lineName: this.$t('BloodOxygenAlarm'),
      },
      // 心率告警柱状图数据
      heartBarData: {
        barId: 'heartId',
        color: ['#FE2888'],
        unit: this.$t('second'),
        xData: [],
        barEchartData: [],
        allXData: [],
        allBarData: [],
        lineName: this.$t('心率告警'),
      },
      // 脱帽数据
      hatList: { xData: [], barEchartData: [], allXData: [], allBarData: [] },
      // 跌落告警柱状图数据
      dropBarData: {
        barId: 'dropId',
        color: ['#35E878'],
        unit: this.$t('second'),
        xData: [],
        barEchartData: [],
        allXData: [],
        allBarData: [],
        lineName: this.$t('DropAlarm'),
      },
      // 一键求助告警柱状图数据
      helpBarData: {
        barId: 'helpId',
        color: ['#FFD96A'],
        unit: this.$t('second'),
        xData: [],
        barEchartData: [],
        allXData: [],
        allBarData: [],
        lineName: this.$t('HelpWarning'),
      },
      // 静电感应告警柱状图数据
      staticBarData: {
        barId: 'staticId',
        color: ['#FFD96A'],
        xData: [],
        barEchartData: [60, 35, 72, 23, 47, 12],
      },
      // 静止告警统计
      amountList: [],
      // 静止告警统计总数
      allAmountList: {
        barId: 'helpId',
        color: ['#FFD96A'],
        unit: this.$t('second'),
        allXData: [],
        allBarData: [],
        lineName: this.$t('StaticAlarm'),
      },
      // 撞击告警数据
      hitList: [],
      // 撞击告警数据所有数据
      allHitList: {
        barId: 'helpId',
        color: ['#FFD96A'],
        unit: this.$t('second'),
        allXData: [],
        allBarData: [],
        lineName: this.$t('ImpactWrning'),
      },
      currenNode: { id: '', startTime: beforeMonthDate() + ' 00:00:00', endTime: nowDate() + ' 23:59:59' },
      SearchDate: {
        pageNum: 1,
        pageSize: 1000,
        alertType: '',
        startTime: beforeMonthDate() + ' 00:00:00',
        endTime: nowDate() + ' 23:59:59',
      },
      // 显示更多的内容弹窗
      showMore: false,
      // 更多的标题传值
      moreTitle: '',
      echartData: [],
      echartType: 'bar',
      barWidth: 10,
      // 进入禁区告警统计
      planeList: [],
      // 进入禁区告警统计总数
      allPlaneList: {
        barId: 'helpId',
        color: ['#FFD96A'],
        unit: this.$t('second'),
        allXData: [],
        allBarData: [],
        lineName: this.$t('OutPlaneAlarm'),
      },

      alarmTotal: {
        heartTotlal: '0',
        bloodTotlal: '0',
        hatTotlal: '0',
        electricitTotlal: '0',
        hitTotlal: '0',
        dropTotlal: '0',
        staticTotlal: '0',
        helpTotlal: '0',
        planeTotle: '0',
      },
    }
  },
  computed: {
    ...mapGetters([
      // 系统是否支持智能帽衬，仅智能帽裎设备支持心率和血氧告警
      'isSupportIH5',
    ]),
  },
  methods: {
    // 日期子组件触发 处理事件
    handleChild() {
      this.$refs.searchDate.searchData()
    },
    // 刷新 并清空数据，请求新数据
    refreshData() {
      this.bloodList = []
      this.heartBarData.allXData = []
      this.heartBarData.allBarData = []
      this.dropBarData.allXData = []
      this.dropBarData.allBarData = []
      this.hatList.allXData = []
      this.hatList.allBarData = []
      this.helpBarData.allXData = []
      this.helpBarData.allBarData = []
      this.hitList = []
      this.amountList = []
      this.echartData = []
      // 跌落
      this.getalertCount('FALL')
      // 撞击
      this.getalertCount('IMPACT')
      // 静止
      this.getalertCount('STATIC')
      this.getalertCount('HEART_RATE')
      this.getalertCount('BLOOD_OXYGEN')
      // 脱帽告警
      this.getalertCount('WEARING_STOP')
      // 进入禁区
      this.getalertCount('FENCE')
      // H5求助告警
      this.getalertCount('SOS')
    },
    // 返回
    backHome() {
      this.showMore = false
      this.refreshData()
      console.log('this.SearchDate.startTime', this.SearchDate.startTime, this.SearchDate.endTime)
    },
    // 查看更多
    checkMore(title, data, type) {
      this.moreTitle = title
      this.echartData = data
      this.echartType = type
      this.showMore = true
    },
    // 结构树当前节点（用户头盔）
    currentNode(item) {
      this.currenNode.id = item.id
      this.refreshData()
    },
    // 日期子组件触发 处理事件
    handleSearch(val) {
      this.SearchDate.startTime = val.logTimestampBegin
      this.SearchDate.endTime = val.logTimestampEnd
      this.refreshData()
    },
    // 告警用户明细以及总数统计
    getalertCount(type) {// NOSONAR
      let param = {
        pageNum: this.SearchDate.pageNum,
        pageSize: this.SearchDate.pageSize,
        alertType: type,
        startTime: this.SearchDate.startTime,
        endTime: this.SearchDate.endTime,
        ouId: this.currenNode.id,
      }
      // 需要处理结束时间的是时分秒
      if (param.endTime) {
        param.endTime = param.endTime.replace('00:00:00', '23:59:59')
      }
      alertCountPage(param).then(res => {
        if (res.state === 0) {
          switch (type) {
            case 'FALL': // FALL:跌落
              this.dropBarData.allXData = []
              this.dropBarData.allBarData = []
              for (var item of res.data.pageData.list) {
                this.dropBarData.allXData.push(item.userName)
                this.dropBarData.allBarData.push(item.number)
              }
              // 总数
              this.alarmTotal.dropTotlal = res.data.pageData.total
              // 数据截取
              if (this.showMore === false && this.dropBarData.allXData.length > 10) {
                this.dropBarData.xData = this.dropBarData.allXData.slice(0, 9)
                this.dropBarData.barEchartData = this.dropBarData.allBarData.slice(0, 9)
              } else {
                this.dropBarData.xData = this.dropBarData.allXData
                this.dropBarData.barEchartData = this.dropBarData.allBarData
              }

              break
            case 'IMPACT': // 撞击
              this.allHitList.allXData = []
              this.allHitList.allBarData = []
              for (var itemHit of res.data.pageData.list) {
                this.allHitList.allXData.push(itemHit.userName)
                this.allHitList.allBarData.push(itemHit.number)
              }
              if (this.showMore === false && res.data.pageData.total > 8) {
                this.hitList = res.data.pageData.list.slice(0, 8)
              } else {
                this.hitList = res.data.pageData.list
              }
              this.alarmTotal.hitTotlal = res.data.pageData.total
              break
            case 'STATIC': // 静止 allXData: [], allBarData: [],
              this.allAmountList.allXData = []
              this.allAmountList.allBarData = []
              for (var itemStatic of res.data.pageData.list) {
                this.allAmountList.allXData.push(itemStatic.userName)
                this.allAmountList.allBarData.push(itemStatic.number)
              }
              if (this.showMore === false && res.data.pageData.total > 4) {
                this.amountList = res.data.pageData.list.slice(0, 4)
              } else {
                this.amountList = res.data.pageData.list
              }
              this.alarmTotal.staticTotlal = res.data.pageData.total
              break
            case 'HEART_RATE': // 心率
              this.heartBarData.allXData = []
              this.heartBarData.allBarData = []
              for (var itemHeart of res.data.pageData.list) {
                this.heartBarData.allXData.push(itemHeart.userName)
                this.heartBarData.allBarData.push(itemHeart.number)
              }

              this.alarmTotal.heartTotlal = res.data.pageData.total

              if (this.showMore === false && this.heartBarData.allXData.length > 10) {
                this.heartBarData.xData = this.heartBarData.allXData.slice(0, 9)
                this.heartBarData.barEchartData = this.heartBarData.allBarData.slice(0, 9)
              } else {
                this.heartBarData.xData = this.heartBarData.allXData
                this.heartBarData.barEchartData = this.heartBarData.allBarData
              }
              // this.echartData = this.heartBarData.xData
              break
            case 'BLOOD_OXYGEN': // BLOOD_OXYGEN:血氧
              this.bloodList = res.data.pageData.list
              this.allBloodList.allXData = []
              this.allBloodList.allBarData = []

              for (var itemBlood of res.data.pageData.list) {
                this.allBloodList.allXData.push(itemBlood.userName)
                this.allBloodList.allBarData.push(itemBlood.number)
              }
              this.alarmTotal.bloodTotlal = res.data.pageData.total

              if (res.data.pageData.total > 4 || this.bloodList.length > 4) {
                this.bloodList = res.data.pageData.list.slice(0, 4)
                this.bloodList = this.bloodList.slice(0, 4)
              } else {
                this.bloodList = res.data.pageData.list
              }
              break
            case 'WEARING_STOP': // 脱帽
              this.hatList.allXData = []
              this.hatList.allBarData = []
              for (var itemHat of res.data.pageData.list) {
                this.hatList.allXData.push(itemHat.userName)
                this.hatList.allBarData.push(itemHat.number)
              }
              this.alarmTotal.hatTotlal = res.data.pageData.total

              if (this.showMore === false && this.hatList.allXData.length > 10) {
                this.hatList.xData = this.hatList.allXData.slice(0, 10)
                this.hatList.barEchartData = this.hatList.allBarData.slice(0, 10)
              } else {
                this.hatList.xData = this.hatList.allXData
                this.hatList.barEchartData = this.hatList.allBarData
              }

              break
            case 'ELECTROSTATIC': // 静电
              this.alarmTotal.electricitTotlal = res.data.pageData.total
              break
            case 'FENCE': // 进入禁区 allXData: [], allBarData: [],
              this.allPlaneList.allXData = []
              this.allPlaneList.allBarData = []
              for (var itemFence of res.data.pageData.list) {
                this.allPlaneList.allXData.push(itemFence.userName)
                this.allPlaneList.allBarData.push(itemFence.number)
              }
              if (this.showMore === false && res.data.pageData.total > 4) {
                this.planeList = res.data.pageData.list.slice(0, 4)
              } else {
                this.planeList = res.data.pageData.list
              }
              this.alarmTotal.planeTotle = res.data.pageData.total
              break
            case 'SOS':
              this.helpBarData.allXData = []
              this.helpBarData.allBarData = []
              this.getemergencyHelp(res.data.pageData.list)
              break
            default:
          }
        }
      })
    },
    // 请求一键求助数据
    getemergencyHelp(data) {// NOSONAR
      let param = {
        pageNum: this.SearchDate.pageNum,
        pageSize: this.SearchDate.pageSize,
        startTime: this.SearchDate.startTime,
        endTime: this.SearchDate.endTime,
        ouId: this.currenNode.id,
      }
      // 需要处理结束时间的是时分秒
      if (param.endTime) {
        param.endTime = param.endTime.replace('00:00:00', '23:59:59')
      }
      emergencyHelpPage(param).then(res => {
        if (res.state === 0) {
          let totalData = Object.assign([],data,res.value.pageData.list)
          totalData.sort(sortData)
          for (var item of totalData) {
            this.helpBarData.allXData.push(item.userName)
            this.helpBarData.allBarData.push(item.number)
          }
          // 总数
          this.alarmTotal.helpTotlal = totalData.length
          // 数据截取
          if (this.showMore === false && this.helpBarData.allXData.length > 10) {
            this.helpBarData.xData = this.helpBarData.allXData.slice(0, 9)
            this.helpBarData.barEchartData = this.helpBarData.allBarData.slice(0, 9)
          } else {
            this.helpBarData.xData = this.helpBarData.allXData
            this.helpBarData.barEchartData = this.helpBarData.allBarData
          }
        }
      })
    },
  },
  mounted() {
    this.warnFlag = true
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.mainContent
  position relative
  height 100%
  .main_content
    height 100%
    .query-box
      display flex
      align-items: center
      position relative
      width calc(100% - 40px)
      margin 0 20px
      margin-top 20px
      padding 8px 0
      pointer-events: auto
      background: #fff;
      box-shadow: 0 0.01041667rem 0.03125rem 0 rgba(0,54,103,0.1);
      >>>.el-button--small
        padding: 10px 15px;/*no*/
      .date_search
        pointer-events: auto
      .serachBtn
        position absolute
        right 20px
        margin-left 10px
  .content_box
    width: 445px;
    height: 47.6%
    margin-left 20px
    margin-top 18px
    pointer-events: auto
    .record
      position relative
      .check_more
        position: absolute
        right: 15px
        top 50%
        transform: translate(0,-50%)
        text-align: center
        line-height: 28px
        padding: 0 7px
        border-radius: 2px
        font-weight: bold
        font-size: 14px
        border-radius: 4px;
        cursor pointer
    .title_box
      .new_title
        height 46px
        line-height 46px
        padding-left 46px
        font-size: 18px;
        font-weight: bold
    .alarm_statu
      height: calc(100% - 46px)
  // 统计图为三行时的重写样式
  .content_box_three_row
    height 47.5%
  .content_box:first-child
    margin-top 0px
  .equipment_num
    width 100%
    height: calc(100% - 46px)
    .amount
      width 50%
      text-align center
      float left
      margin-top 10px
      .num
        width 116px
        height 106px
        margin 0 auto
        line-height 116px
        font-size: 28px
        color: #fff
        font-weight 600
        bg-image-full('~@/icon/home/circular.png')
      .equip_name
        width 100%
        margin-top 6px
        color #333
        font-size: 16px
        font-weight: bold
        overflow:hidden
        white-space:nowrap
        text-overflow:ellipsis
    .amount:last-child
      margin-right 0
  .left_li
    float: left
    height calc(100% - 100px)
    padding-top 20px
  .center-li
    width: calc(100% - 970px)
    height calc(100% - 80px)
    float: left
    margin 0 20px
    padding-top 20px
    .center-alarm
      width 100%
      display: flex
      overflow: hidden
      .content_box
        width 48.9%
        height 100%
        float left
        margin-top 0px
        margin-left 20px
      .content_box:first-child
        margin-left 0px
    .alarm-up
      height 46.2%
    .alarm-down
      height: 46.2%
      margin-top 20px
  .right_li
    float right
    height calc(100% - 100px)
    padding-top 20px
    .content_box
      margin 18px 20px 0 0
    .content_box:first-child
      margin-top 0px
    .hit_hat
      display: flex
      justify-content: center
  .hit_alarm
    width: calc(100% - 20px)
    height calc(100% - 50px)!important
    margin: 10px
    overflow hidden
    color: #333
    text-align: center
    .safety_hat
      float: left
      width: 25%
      height 48%
      box-sizing:border-box
      border-right: 1px solid rgba(#05A3CF, 0.1)
      position relative
      .hat-num
        position absolute
        left 50%
        top 50%
        transform: translate(-50%,-50%)
        width: 100%
      .hit_num
        font-size: 28px
        font-weight: bold
        color: #0E65DD
      p
        width 100%
        overflow:hidden
        white-space:nowrap
        text-overflow:ellipsis
        margin-top: 6px
        font-size: 14px
    .safety_hat:nth-child(4),.safety_hat:nth-child(8)
      border-right: none
    .safety_hat:nth-child(1),.safety_hat:nth-child(2),.safety_hat:nth-child(3),.safety_hat:nth-child(4)
      border-bottom: 1px solid rgba(#05A3CF, 0.1)
    .three_hat
      float: left
      width: 25%
      height 80%
      box-sizing:border-box
      border-right: 2px solid rgba(#05A3CF, 0.1)
      .hit_num
        font-size: 28px
        font-weight: bold
        color: #0E65DD
        line-height: 56px
        margin-top: 16px
      p
        margin-top: 20px
        font-size: 14px
    .three_hat:last-child
      border-right: none
  .moveR-enter-active, .moveR-leave-active
    transition all 0.7s linear
    transform translateX(0)
  .moveR-enter, .moveR-leave
    transform translateX(100%)
  .moveR-leave-to
    transform translateX(100%)
  .ih5-center
    .center-alarm
      .content_box
        width 100%
// 深色样式
.theme-dark
  .mainContent
    .main_content
      .query-box
        background: rgba(0,42,150,0.8);
        box-shadow: 0 0.01041667rem 0.03125rem 0 rgba(0,54,103,0.1);
  .equipment_num
    .amount
      .num
        color: #00E4FF
        bg-image-full('~@/icon/home/ic_circular.png')
      .equip_name
        color #fff
  .hit_alarm
    color: #fff
    .safety_hat
      border-right: 1px solid rgba(#65C6E7, 0.2)
      .hit_num
        color: #00E4FF
    .three_hat
      border-right: 2px solid rgba(#65C6E7, 0.1)
      .hit_num
        color: #00E4FF
</style>
